<template>
    <div class="bundles">
        <div v-if="loading" class="spinner-container"><div class="spinner lds-ripple"><div></div><div></div></div></div>
        <Bundle v-if="bundles && !loading" v-for="b in bundles" :bundle="b" />
        <div v-if="bundles && bundles.length === 0" class="alert alert-warning">
            Well, it's a shame but we don't have any bundles at this point.
        </div>
        <Paggination v-if="currentPage && lastPage && !loading" :currentPage="currentPage" :lastPage="lastPage" @navigate="setPage" />
    </div>
</template>

<script>
import api from "@app/util/api";
import Bundle from "./bundle";
import Paggination from "./pagination.vue";

export default {
    components: { Bundle, Paggination },
    data() {
        return {
            loading: false,
            bundles: null,
            links: null,
            currentPage: null,
            lastPage: null,
        };
    },
    beforeMount() {
        this.setPage(1);
    },
    methods: {
        setPage(page) {
            this.loading = true;
            api({ method: "GET", url: `/bundles?active=1&pg=${page}` }).then((res) => {
                if (res.status >= 200 && res.status <= 300) {
                    this.bundles = res.data.data;
                    this.currentPage = res.data.meta.current_page;
                    this.lastPage = res.data.meta.last_page;
                    this.loading = false;
                }
                if (res.status === 401) {
                    window.location.href = "/auth/signin";
                }
            });
        },
    },
};
</script>

<style scoped>
.bundles {
    display: flex;
    gap: 16px;
    flex-direction: column;
}
.spinner-container {
    display: flex;
    justify-content: center;
}
</style>
